// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__IJTSP","label":"SetPasswdForm_label__372mM"};